var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH092(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f4f4;}.cls-2{fill:#e8e8e8;}.cls-3{fill:#cecece;}.cls-4{fill:#fff;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.83,103.67c-12.57,50.45-60.39,90.6-107.41,88.08C28.27,189.16,1.78,143.18,17.78,90.77,33.25,40.12,82.4,4.02,127.1,8.52c43.72,4.4,68.89,46.33,56.72,95.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.89,95.24c-9.55,35.56-44.89,63.41-79.22,61.41-34.91-2.04-54.26-33.98-42.94-70.5,11.05-35.66,47.08-61.5,80.22-58.52,32.62,2.93,51.28,32.86,41.95,67.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.72,102.48c-5.18-20.94-1.75-59.41-1.75-59.41l-9.42-1.94s-24.43,34.46-44.11,50.84l-6.37,5.28c-6.69,17.06,4.59,26.2,22.9,29.76,18.3,3.09,34.21-.99,40.42-17.83l-1.68-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.02,96.82c-2.65-10.75-.83-30.63-.83-30.63l-4.87-.98s-12.55,17.82-22.56,26.18l-3.22,2.68c-3.34,8.64,2.37,13.29,11.65,15.15,9.32,1.63,17.46-.39,20.68-8.97l-.85-3.43Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 200,
    height: 200
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH092);
export default __webpack_public_path__ + "static/media/H09-2.2eeb3cd69566ec223bfb639f9fbf3e83.svg";
export { ForwardRef as ReactComponent };